import { render, staticRenderFns } from "./PaymentRequisitionDetailPage.vue?vue&type=template&id=8fef0a56&"
import script from "./PaymentRequisitionDetailPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentRequisitionDetailPage.vue?vue&type=style&index=0&id=8fef0a56&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports